import React from 'react';
import PropTypes from 'prop-types';

// all svgs from material.io/tools/icons

const defaultSize = '24px';
const defaultForegroundColor = 'white';
const defaultBackgroundColor = 'none';

export const KEYBOARD = 'KEYBOARD';
const keyboard = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        <path
            d="M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"/>
    </svg>;

export const CAMERA = 'CAMERA';
const camera = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="3.2"/>
        <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        <path
            d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
    </svg>;

export const EDIT = 'EDIT';
const edit = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        <path
            d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
    </svg>;

export const SAVE = 'SAVE';
const save = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <g id="Bounding_Boxes">
            <g id="ui_x5F_spec_x5F_header_copy_3" display="none">
            </g>
            <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        </g>
        <g id="Outline">
            <g id="ui_x5F_spec_x5F_header" display="none">
            </g>
            <g>
                <path
                    d="M17,3H5C3.89,3,3,3.9,3,5v14c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V7L17,3z M19,19H5V5h11.17L19,7.83V19z"/>
                <path d="M12,12c-1.66,0-3,1.34-3,3c0,1.66,1.34,3,3,3s3-1.34,3-3C15,13.34,13.66,12,12,12z"/>
                <rect x="6" y="6" width="9" height="4"/>
            </g>
        </g>
    </svg>;

export const ADD = 'ADD';
const add = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
    </svg>;

export const LOADING = 'LOADING';
const loading = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        <path
            d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/>
    </svg>;

export const REMOVE = 'REMOVE';
const remove = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <g id="Header_x2F_BG" display="none">
            <rect x="-314" y="-270" display="inline" fill="#F1F1F2" width="520" height="520"/>
        </g>
        <g id="Bounding_Boxes">
            <g id="ui_x5F_spec_x5F_header_copy_3">
            </g>
            <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        </g>
        <g id="Rounded" display="none">
            <g id="ui_x5F_spec_x5F_header_copy_5" display="inline">
            </g>
            <path display="inline" d="M6,19c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V9c0-1.1-0.9-2-2-2H8C6.9,7,6,7.9,6,9V19z M9.17,11.17
		L9.17,11.17c0.39-0.39,1.02-0.39,1.41,0L12,12.59l1.42-1.42c0.39-0.39,1.02-0.39,1.41,0l0,0c0.39,0.39,0.39,1.02,0,1.41L13.41,14
		l1.42,1.42c0.39,0.39,0.39,1.02,0,1.41l0,0c-0.39,0.39-1.02,0.39-1.41,0L12,15.41l-1.42,1.42c-0.39,0.39-1.02,0.39-1.41,0l0,0
		c-0.39-0.39-0.39-1.02,0-1.41L10.59,14l-1.42-1.42C8.78,12.2,8.78,11.56,9.17,11.17z M15.5,4l-0.71-0.71
		C14.61,3.11,14.35,3,14.09,3H9.91C9.65,3,9.39,3.11,9.21,3.29L8.5,4H6C5.45,4,5,4.45,5,5v0c0,0.55,0.45,1,1,1h12c0.55,0,1-0.45,1-1
		v0c0-0.55-0.45-1-1-1H15.5z"/>
        </g>
        <g id="Sharp" display="none">
            <g id="ui_x5F_spec_x5F_header_copy_4" display="inline">
            </g>
            <path display="inline" d="M6,21h12V7H6V21z M8.46,11.88l1.41-1.41L12,12.59l2.12-2.12l1.41,1.41L13.41,14l2.12,2.12l-1.41,1.41
		L12,15.41l-2.12,2.12l-1.41-1.41L10.59,14L8.46,11.88z M15.5,4l-1-1h-5l-1,1H5v2h14V4H15.5z"/>
        </g>
        <g id="Outline">
            <g id="ui_x5F_spec_x5F_header">
            </g>
            <g>
                <polygon points="14.12,10.47 12,12.59 9.87,10.47 8.46,11.88 10.59,14 8.47,16.12 9.88,17.53 12,15.41 14.12,17.53 15.53,16.12
			13.41,14 15.53,11.88 		"/>
                <polygon points="15.5,4 14.5,3 9.5,3 8.5,4 5,4 5,6 19,6 19,4 		"/>
                <path d="M6,19c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V7H6V19z M8,9h8v10H8V9z"/>
            </g>
        </g>
        <g id="Duotone" display="none">
            <g id="ui_x5F_spec_x5F_header_copy_2" display="inline">
            </g>
            <g display="inline">
                <path opacity="0.3" d="M16,9H8v10h8V9z M15.53,16.12l-1.41,1.41L12,15.41l-2.12,2.12l-1.41-1.41L10.59,14l-2.13-2.12l1.41-1.41
			L12,12.59l2.12-2.12l1.41,1.41L13.41,14L15.53,16.12z"/>
                <g>
                    <polygon points="14.12,10.47 12,12.59 9.87,10.47 8.46,11.88 10.59,14 8.47,16.12 9.88,17.53 12,15.41 14.12,17.53 15.53,16.12
				13.41,14 15.53,11.88 			"/>
                    <polygon points="15.5,4 14.5,3 9.5,3 8.5,4 5,4 5,6 19,6 19,4 			"/>
                    <path d="M6,19c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V7H6V19z M8,9h8v10H8V9z"/>
                </g>
            </g>
        </g>
        <g id="Fill" display="none">
            <g id="ui_x5F_spec_x5F_header_copy" display="inline">
            </g>
            <path display="inline" d="M6,19c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V7H6V19z M8.46,11.88l1.41-1.41L12,12.59l2.12-2.12l1.41,1.41
		L13.41,14l2.12,2.12l-1.41,1.41L12,15.41l-2.12,2.12l-1.41-1.41L10.59,14L8.46,11.88z M15.5,4l-1-1h-5l-1,1H5v2h14V4H15.5z"/>
        </g>
        <g id="nyt_x5F_exporter_x5F_info" display="none">
        </g>
    </svg>;

export const CLOSE = 'CLOSE';
const close = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    </svg>;

export const CHECK_MARK = 'CHECK_MARK';
const checkmark = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/>
    </svg>;

export const CLOUD_UPLOAD = 'CLOUD_UPLOAD';
const cloud_upload = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <g id="Bounding_Boxes">
            <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        </g>
        <g id="Outline">
            <g id="ui_x5F_spec_x5F_header">
            </g>
            <g>
                <path d="M19.35,10.04C18.67,6.59,15.64,4,12,4C9.11,4,6.6,5.64,5.35,8.04C2.34,8.36,0,10.91,0,14c0,3.31,2.69,6,6,6h13
			c2.76,0,5-2.24,5-5C24,12.36,21.95,10.22,19.35,10.04z M19,18H6c-2.21,0-4-1.79-4-4c0-2.05,1.53-3.76,3.56-3.97l1.07-0.11
			l0.5-0.95C8.08,7.14,9.94,6,12,6c2.62,0,4.88,1.86,5.39,4.43l0.3,1.5l1.53,0.11C20.78,12.14,22,13.45,22,15
			C22,16.65,20.65,18,19,18z"/>
                <polygon points="8,13 10.55,13 10.55,16 13.45,16 13.45,13 16,13 12,9 		"/>
            </g>
        </g>
    </svg>;

export const BACKSPACE = 'BACKSPACE';
const backspace = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <g id="Bounding_Boxes">
            <g id="ui_x5F_spec_x5F_header_copy_3" display="none">
            </g>
            <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        </g>
        <g id="Outline">
            <g id="ui_x5F_spec_x5F_header" display="none">
            </g>
            <g>
                <path d="M22,3H7C6.31,3,5.77,3.35,5.41,3.88L0,12l5.41,8.11C5.77,20.64,6.31,21,7,21h15c1.1,0,2-0.9,2-2V5C24,3.9,23.1,3,22,3z
			 M22,19L7.07,19L2.4,12l4.66-7c0,0,0,0,0,0H22V19z"/>
                <polygon
                    points="10.41,17 14,13.41 17.59,17 19,15.59 15.41,12 19,8.41 17.59,7 14,10.59 10.41,7 9,8.41 12.59,12 9,15.59 		"/>
            </g>
        </g>
    </svg>;

export const RESTORE = 'RESTORE';
const restore = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <g id="Bounding_Boxes">
            <g id="ui_x5F_spec_x5F_header_copy_3" display="none">
            </g>
            <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        </g>
        <g id="Rounded" display="none">
            <g id="ui_x5F_spec_x5F_header_copy_5">
            </g>
            <g display="inline">
                <path d="M13.25,3c-5.09-0.14-9.26,3.94-9.26,9H2.2c-0.45,0-0.67,0.54-0.35,0.85l2.79,2.8c0.2,0.2,0.51,0.2,0.71,0l2.79-2.8
			C8.46,12.54,8.23,12,7.79,12H5.99c0-3.9,3.18-7.05,7.1-7c3.72,0.05,6.85,3.18,6.9,6.9c0.05,3.91-3.1,7.1-7,7.1
			c-1.61,0-3.1-0.55-4.28-1.48c-0.4-0.31-0.96-0.28-1.32,0.08l0,0C6.97,18.03,7,18.73,7.47,19.1c1.52,1.19,3.44,1.9,5.52,1.9
			c5.05,0,9.14-4.17,9-9.26C21.86,7.05,17.94,3.13,13.25,3z"/>
                <path d="M12.74,8L12.74,8c-0.41,0-0.75,0.34-0.75,0.75v3.68c0,0.35,0.19,0.68,0.49,0.86l3.12,1.85c0.36,0.21,0.82,0.09,1.03-0.26
			c0.21-0.36,0.09-0.82-0.26-1.03l-2.88-1.71v-3.4C13.49,8.34,13.16,8,12.74,8z"/>
            </g>
        </g>
        <g id="Sharp" display="none">
            <g id="ui_x5F_spec_x5F_header_copy_4">
            </g>
            <g display="inline">
                <path d="M13,3c-4.97,0-9,4.03-9,9H1l4,3.99L9,12H6c0-3.87,3.13-7,7-7s7,3.13,7,7s-3.13,7-7,7c-1.93,0-3.68-0.79-4.94-2.06
			l-1.42,1.42C8.27,19.99,10.51,21,13,21c4.97,0,9-4.03,9-9C22,7.03,17.97,3,13,3z"/>
                <polygon points="12,8 12,13 16.25,15.52 17.02,14.24 13.5,12.15 13.5,8 		"/>
            </g>
        </g>
        <g id="Outline">
            <g id="ui_x5F_spec_x5F_header" display="none">
            </g>
            <g>
                <path d="M13,3c-4.97,0-9,4.03-9,9H1l4,3.99L9,12H6c0-3.87,3.13-7,7-7s7,3.13,7,7s-3.13,7-7,7c-1.93,0-3.68-0.79-4.94-2.06
			l-1.42,1.42C8.27,19.99,10.51,21,13,21c4.97,0,9-4.03,9-9C22,7.03,17.97,3,13,3z"/>
                <polygon points="12,8 12,13 16.25,15.52 17.02,14.24 13.5,12.15 13.5,8 		"/>
            </g>
        </g>
        <g id="Duotone" display="none">
            <g id="ui_x5F_spec_x5F_header_copy_2">
            </g>
            <g display="inline">
                <path d="M13,3c-4.97,0-9,4.03-9,9H1l4,3.99L9,12H6c0-3.87,3.13-7,7-7s7,3.13,7,7s-3.13,7-7,7c-1.93,0-3.68-0.79-4.94-2.06
			l-1.42,1.42C8.27,19.99,10.51,21,13,21c4.97,0,9-4.03,9-9C22,7.03,17.97,3,13,3z"/>
                <polygon points="12,8 12,13 16.25,15.52 17.02,14.24 13.5,12.15 13.5,8 		"/>
            </g>
        </g>
        <g id="Material" display="none">
            <g id="ui_x5F_spec_x5F_header_copy">
            </g>
            <g display="inline">
                <path d="M13,3c-4.97,0-9,4.03-9,9H1l4,3.99L9,12H6c0-3.87,3.13-7,7-7s7,3.13,7,7s-3.13,7-7,7c-1.93,0-3.68-0.79-4.94-2.06
			l-1.42,1.42C8.27,19.99,10.51,21,13,21c4.97,0,9-4.03,9-9C22,7.03,17.97,3,13,3z"/>
                <polygon points="12,8 12,13 16.25,15.52 17.02,14.24 13.5,12.15 13.5,8 		"/>
            </g>
        </g>
    </svg>;

export const FILTER = 'FILTER';
const filter = (props) =>
    <svg xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : defaultSize}
         height={props.height ? props.height : defaultSize}
         viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
        <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/>
    </svg>;

export const NO_FILTER = 'NO_FILTER';
const no_filter = (props) =>
    <React.Fragment>
        <svg xmlns="http://www.w3.org/2000/svg"
             width={props.width ? props.width : defaultSize}
             height={props.height ? props.height : defaultSize}
             viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill={props.fillSecond ? props.fillSecond : defaultBackgroundColor}/>
            <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"/>
        </svg>
    </React.Fragment>;

const render = ({iconName}) => {
    switch (iconName) {
        case KEYBOARD:
            return keyboard;
        case CAMERA:
            return camera;
        case EDIT:
            return edit;
        case SAVE:
            return save;
        case ADD:
            return add;
        case LOADING:
            return loading;
        case REMOVE:
            return remove;
        case CLOSE:
            return close;
        case CHECK_MARK:
            return checkmark;
        case CLOUD_UPLOAD:
            return cloud_upload;
        case BACKSPACE:
            return backspace;
        case RESTORE:
            return restore;
        case FILTER:
            return filter;
        case NO_FILTER:
            return no_filter;
        default:
            return () => undefined;
    }
};

/**
 * General Icon component.
 *
 * To add:
 *  - Add associated function for svg.
 *      export const KEYBOARD = 'KEYBOARD';
 *      const keyboard = (props) => <svg></svg>;
 *  - Add to render() switch statement.
 *  - Add constant to Icon.PropTypes.iconName
 */
const Icon = (props) => {
    return (
        <div
            style={{
                fill: props.fill ? props.fill : defaultForegroundColor,
                width: props.width ? props.width : defaultSize,
                height: props.height ? props.height : defaultSize
            }}
            className={props.spin && 'spinner'}
        >
            {render({...props})(props)}
        </div>
    );
};

Icon.propTypes = {
    iconName: PropTypes.oneOf([
        KEYBOARD,
        CAMERA,
        EDIT,
        SAVE,
        ADD,
        LOADING,
        REMOVE,
        CLOSE,
        CHECK_MARK,
        CLOUD_UPLOAD,
        BACKSPACE,
        RESTORE,
        FILTER,
        NO_FILTER
    ]).isRequired,

    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
    fillSecond: PropTypes.string,
    spin: PropTypes.bool
};

export default Icon;


// WEBPACK FOOTER //
// ./src/component/Icon.jsx